import React from 'react';
import { useNamespacedTranslation } from '../../../../../../../../hooks/useNamespacedTranslation';
import FormattedDate from '../../../../../../../../components/date/FormattedDate';
import { usePositionsQuery } from '../../../../../../__generated__/graphql';

export type PositionChangeData = {
  originalId?: string;
  newId?: string;
  endDate?: string;
  currentPositionId?: string;
  newPositionId?: string;
  effectiveDate?: string;
  currentPositionName?: string;
  newPositionName?: string;
};

export type PositionChangeOverviewProps = {
  positionChange: PositionChangeData;
};

export const PositionChangeOverview: React.FC<PositionChangeOverviewProps> = ({
  positionChange,
}) => {
  const t = useNamespacedTranslation('changeRequests');

  const currentPositionId =
    positionChange?.originalId || positionChange?.currentPositionId;
  const newPositionId = positionChange?.newId || positionChange?.newPositionId;
  const effectiveDate = positionChange?.effectiveDate;
  const endDate = positionChange?.endDate;

  const { data: positionsData } = usePositionsQuery({
    variables: { filter: { activeOnly: false } },
    skip: !currentPositionId && !newPositionId,
  });

  const currentPosition = positionsData?.positions?.find(
    (p) => p.Id === currentPositionId,
  );
  const newPosition = positionsData?.positions?.find(
    (p) => p.Id === newPositionId,
  );

  const displayNewPositionName =
    positionChange.newPositionName ||
    newPosition?.flair__Title__c ||
    newPosition?.Name;

  const displayCurrentPositionName =
    positionChange.currentPositionName ||
    currentPosition?.flair__Title__c ||
    currentPosition?.Name;

  return (
    <div className="bg-light rounded p-4 mb-2">
      <div className="fw-bold mb-2">{t('previewModal.positionChange')}</div>
      <div className="text-break">
        <strong>{displayNewPositionName}</strong>
        {effectiveDate && (
          <div className="text-muted small">
            {t('previewModal.effectiveDate')}
            : <FormattedDate day={effectiveDate} format="short" />
            {endDate && (
              <>
                {' - '}
                <FormattedDate day={endDate} format="short" />
              </>
            )}
          </div>
        )}
      </div>
      <div className="text-muted text-decoration-line-through text-break">
        {displayCurrentPositionName}
      </div>
    </div>
  );
};
